<div [class]="skinName">
  <div id="model-pay" class="account-page">
    @if (page !== 'account' && page !== 'contentDetail' && (step !== 4 && page === 'contentDetail')) {
      <div id="close-pay-align" [ngStyle]="{'padding-bottom':step === 1?'0px':'10px'}">
        <img id="close-pay" class="cursor-pointer" (click)="closePayment()" src="branding/theme/assets/static_assets/ic-cross-round-on-dbg.svg" alt="close payment">
      </div>
    }
    @if (step === 1) {
      <div>
        <app-select-plan [page]="page" [planData]="planData" (emitSelectPlan)="selectedPlan($event)" (emitStep)="getSignStep($event)" [paymentDialog]="paymentDialog"></app-select-plan>
      </div>
    }
    @if (step === 2) {
      <div id="card-pay" class="form-card" [ngClass]="{'account-card': page=== 'account'}">
        <app-payment-method-type [step]="step" (emitStep)="getSignStep($event)" [page]="page" class="common-bg" (emitCardMethod)="cardMethod($event)" [auth_head]="true"></app-payment-method-type>
      </div>
    }
    @if (step === 3) {
      <div id="card-pay" class="form-card" >
        <div id="pay-detail">{{ configService.localeKeys?.channels_paymnt_details_desc || 'Please, enter your payment details below.'}}</div>
        <!-- <div [ngClass]="changePlan.oldUser ? 'subTitleTopPad' : 'subTitleBotPad'" id="pay-sub-title">{{ configService.localeKeys?.['plans.set_up_your_payment.text'] }}</div> -->
        <app-signup-step (emitStep)="getSignStep($event)" [showBackArrow]="true" [gotToPreviousPopUp]="true" [page]="page" [currentStep]="paymentMethodLength > 1 ? '3' : '2'" [showChangePlan]="true"></app-signup-step>
        <app-plan-info [hidden] = "payment_type ==='ideal'" [oldUser]="changePlan.oldUser" [showIntent]="true" ></app-plan-info>
        <app-card-payment [hidden] = "payment_type!='card'" [page]="page" (emitCardPayment)="cardPayment($event)" [payButton]="false" #changePlan></app-card-payment>
        <app-plan-info  [idealBankValidationText]="true" [hidden] = "payment_type!='ideal'" [oldUser]="changePlan.oldUser" [showIntent]="false" [paymentIntent]="configService.localeKeys?.['plans.set_up_your_payment.text']"></app-plan-info>
        <app-ideal-payment-bank [hidden] = "payment_type!='ideal'"  (emitIdealPayment)="idealPayment($event)" [enableIdealPayment]="true"></app-ideal-payment-bank>
      </div>
    }
    @if (step === 4) {
      <div id="pay-success">
        <app-account-created [paymentDialog]="paymentDialog" [btnText]="configService.localeKeys?.['welcome.start_watching.text']"
        [subTitleText]="subTitleText"></app-account-created>
      </div>
    }
  </div>
</div>